import React from "react";

import { PageMessage } from "@picklebet/ui";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";

import { ReactComponent as WarningPending } from "assets/illustrations/warning-pending.svg";

type CheckCooldownProps = {
  permission: string;
  children?: React.ReactNode;
  type: "deposit" | "withdraw";
};

const CheckCooldown = ({ children, permission, type }: CheckCooldownProps) => {
  if (
    ["CC_COOLDOWN", "VERIFICATION_STATUS_COOLDOWN", "COOLDOWN"].includes(
      permission,
    )
  ) {
    return (
      <PageMessage
        image={<WarningPending />}
        title={`Your account is in Cooldown`}
        subTitle={`During the Cooldown period you are not permitted to ${type}`}
      >
        <SupportLink openLiveChat type={`button`}>
          Contact Support
        </SupportLink>
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { CheckCooldown };
